import { render, staticRenderFns } from "./SharedResponsibility.vue?vue&type=template&id=0e805518"
import script from "./SharedResponsibility.vue?vue&type=script&lang=js"
export * from "./SharedResponsibility.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports